__turbopack_context__.v({
  "wrapper": "rTXdqG_wrapper",
});
